<template lang="pug">
v-card
    v-card-title.d-flex.justify-space-between.align-center
        span {{$t('EMAILATTACHMENTSDIALOG.TITLE')}}
        v-btn(icon @click='onCancel')
            v-icon mdi-close
    v-divider.my-2
    v-card-text
        v-list(two-line)
            template(v-for="item in emailAttachmentData")
                v-list-item
                    v-list-item-avatar
                        v-icon(size='30') icon-attach
                    v-list-item-content
                        a.t-primary.mb-1(:href='item.attachment' target='_blank') {{ getFileName(item.attachment) }}
</template>

<script>
	import Vue from 'vue';

	export default Vue.extend({
        props: {
            emailAttachmentData: {
                type: Array,
                required: true,
            },
        },
        methods: {
            onCancel() {
                this.$emit('emitEmailAttachmentsDialog', false);
            },
            getFileName(filePath) {
                filePath = filePath.split("attachment/")
                return decodeURI(filePath[1].replace(/^.*[\\/]/, '').split('?')[0]);
            },
        }
	});
</script>
